<template>
  <div class="main-factors">
    <div class="main-factors__filters">
      <c-input
        v-model="filialLocal"
        class="main-factors__filters__filial"
        label="Филиал"
        type="select"
        :searchable="true"
        :clearable="true"
        :items="filialItems"
        placeholder="Все"
      />
      <c-input
        ref="mainFactorsPeriod"
        v-model="periodLocal"
        class="main-factors__filters__period"
        label="За период"
        placeholder="00.00.0000 - 00.00.0000"
        type="period"
        icon="calendar"
        :clearable="true"
        :icon-right="true"
      />
      <div class="main-factors__filters__buttons">
        <c-button
          class="main-factors__filters__buttons__apply"
          label="Применить"
          color="primary"
          @click="applyFilters"
        />
        <c-button class="main-factors__filters__buttons__reset" label="Сбросить" @click="resetFilters" />
      </div>
    </div>
    <c-switcher
      v-model="switcherLocal"
      class="main-factors__switcher"
      type="group"
      :items="[
        { label: 'По сменам', value: 'shifts' },
        { label: 'Суммарные показатели', value: 'summary' },
      ]"
    />
    <div
      class="main-factors__tabs"
      :class="{
        'main-factors__tabs__shifts': switcherLocal === 'shifts',
      }"
    >
      <c-data-table-personal-employee
        v-if="switcherLocal === 'shifts' && !isDataLoading"
        id="mainFactorsShiftsTable"
        ref="table"
        class="main-factors__tabs__in__shifts__table"
        empty-records-label="Записи не найдены"
        :levels="1"
        :disabled-columns="[]"
        :data="tableData"
      />
      <div v-if="switcherLocal === 'summary' && !isDataLoading" class="main-factors__tabs__summary">
        <div
          v-for="item in summaryLocalData"
          :key="`summary-${item.filial_name}`"
          class="main-factors__tabs__summary__item"
        >
          <div class="main-factors__tabs__summary__item__summ">
            <div class="main-factors__tabs__summary__item__summ__title">{{ item.filial_name }}</div>
            <div class="main-factors__tabs__summary__item__summ__count">
              {{ item.total === 0 ? 0 : formatAmount(item.total) }} {{currencyLabel}}
            </div>
            <div class="main-factors__tabs__summary__item__summ__time">
              <c-button
                v-b-popover.html="{ trigger: 'hover', content: 'Какой-то тултип', placement: 'top' }"
                class="main-factors__tabs__summary__item__summ__time__icon"
                size="iconic"
                icon="time"
              />
              <div class="main-factors__tabs__summary__item__summ__time__title">
                {{ item.worked_day }} смен,
                {{ !Number.isInteger(item.worked_hour) ? item.worked_hour.toFixed(2) : item.worked_hour }} ч 00 мин
              </div>
            </div>
          </div>
          <div class="main-factors__tabs__summary__item__money">
            <div class="main-factors__tabs__summary__item__money__main">
              <div class="main-factors__tabs__summary__item__money__main__count">
                {{ item.paid === 0 ? 0 : formatAmount(item.paid) }} {{currencyLabel}}
              </div>
              <div class="main-factors__tabs__summary__item__money__main__title">Основная часть</div>
            </div>
            <div
              class="main-factors__tabs__summary__item__money__variable"
              :class="{
                'main-factors__tabs__summary__item__money__variable__green': item.bonus > 0,
                'main-factors__tabs__summary__item__money__variable__grey': item.bonus === 0,
              }"
            >
              <div class="main-factors__tabs__summary__item__money__variable__count">
                {{ item.bonus === 0 ? 0 : formatAmount(item.bonus) }} {{currencyLabel}}
              </div>
              <div class="main-factors__tabs__summary__item__money__variable__title">Переменная часть</div>
            </div>
            <div
              class="main-factors__tabs__summary__item__money__depremal main-factors__tabs__summary__item__money__depremal__grey"
              :class="{
                'main-factors__tabs__summary__item__money__depremal__red': item.penalty > 0,
                'main-factors__tabs__summary__item__money__depremal__grey': item.penalty === 0,
              }"
            >
              <div class="main-factors__tabs__summary__item__money__depremal__count">
                {{ item.penalty === 0 ? 0 : formatAmount(item.penalty) }} {{currencyLabel}}
              </div>
              <div class="main-factors__tabs__summary__item__money__depremal__title">Депрем-е</div>
            </div>
            <div
              class="main-factors__tabs__summary__item__money__incentives"
              :class="{
                'main-factors__tabs__summary__item__money__incentives__green': item.summ_bonus > 0,
                'main-factors__tabs__summary__item__money__incentives__grey': item.summ_bonus === 0,
              }"
            >
              <div class="main-factors__tabs__summary__item__money__incentives__count">
                {{ item.summ_bonus === 0 ? 0 : formatAmount(item.summ_bonus) }} {{currencyLabel}}
              </div>
              <div class="main-factors__tabs__summary__item__money__incentives__title">Поощрения</div>
            </div>
            <div
              class="main-factors__tabs__summary__item__money__fines"
              :class="{
                'main-factors__tabs__summary__item__money__fines__red': item.summ_fine > 0,
                'main-factors__tabs__summary__item__money__fines__grey': item.summ_fine === 0,
              }"
            >
              <div class="main-factors__tabs__summary__item__money__fines__count">
                {{ item.summ_fine === 0 ? 0 : formatAmount(item.summ_fine) }} {{currencyLabel}}
              </div>
              <div class="main-factors__tabs__summary__item__money__fines__title">Штрафы</div>
              <div v-if="item.count_fine" class="main-factors__tabs__summary__item__money__fines__amount">
                {{ item.count_fine }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <c-loader
        v-if="isDataLoading"
        class="main-factors__tabs__loader"
        label="Данные загружаются"
        :active="isDataLoading"
        height="200"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls2/Switcher";
import Loader from "@/components/loader";
import DataTablePersonalEmployee from "@/pages/personal-employee/additions/data-table-personal-employee";

export default {
  name: "personal-employee-main-factors",
  components: {
    "c-button": Button,
    "c-input": Input,
    "c-switcher": Switcher,
    "c-loader": Loader,
    "c-data-table-personal-employee": DataTablePersonalEmployee,
  },

  data() {
    return {
      currencyLabel: '฿',
      isDataLoading: false,
      filialLocal: null,
      filialItems: [],
      periodLocal: null,
      periodStart: this.$route.query.periodStart ? this.$route.query.periodStart : "",
      periodEnd: this.$route.query.periodEnd ? this.$route.query.periodEnd : "",
      switcherLocal: "shifts",
      shiftsLocalData: [],
      summaryLocalData: [],
      tableData: {
        type: "main-factors",
        columns: [],
        records: [],
        actions: true,
        enabledFields: [],
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
      },
    };
  },

  computed: {
    ...mapGetters("personalEmployee", ["getTableColumnsMainFactors"]),
  },

  watch: {
    switcherLocal(value) {
      this.getDataWorkerMainFactors(value);
    },
  },

  mounted() {
    if (this.periodStart.length > 0 && this.periodEnd.length > 0) {
      this.$refs.mainFactorsPeriod.period.start.input = this.periodStart;
      this.$refs.mainFactorsPeriod.period.end.input = this.periodEnd;

      const period = `${this.periodStart}-${this.periodEnd}`;
      const today = moment().startOf("day").format("DD.MM.YYYY").toString();
      const yesterday = moment().startOf("day").subtract(1, "day").format("DD.MM.YYYY").toString();
      const firstDayCurrentWeek = moment().startOf("day").startOf("week").format("DD.MM.YYYY").toString();
      const lastDayCurrentWeek = moment().startOf("day").format("DD.MM.YYYY").toString();
      const firstDayLastWeek = moment()
        .startOf("day")
        .startOf("week")
        .subtract(1, "week")
        .format("DD.MM.YYYY")
        .toString();
      const lastDayLastWeek = moment().startOf("day").endOf("week").subtract(1, "week").format("DD.MM.YYYY").toString();
      const sevenDayAgo = moment().startOf("day").subtract(6, "day").format("DD.MM.YYYY").toString();
      const firstDayCurrentMonth = moment().startOf("day").startOf("month").format("DD.MM.YYYY").toString();
      const firstDayLastMonth = moment()
        .startOf("day")
        .subtract(1, "month")
        .startOf("month")
        .format("DD.MM.YYYY")
        .toString();
      const lastDayLastMonth = moment()
        .startOf("day")
        .subtract(1, "month")
        .endOf("month")
        .format("DD.MM.YYYY")
        .toString();

      if (today === this.periodStart && today === this.periodEnd) {
        this.$refs.mainFactorsPeriod.dateValue = "Сегодня";
      } else if (yesterday === this.periodStart && yesterday === this.periodEnd) {
        this.$refs.mainFactorsPeriod.dateValue = "Вчера";
      } else if (firstDayCurrentWeek === this.periodStart && lastDayCurrentWeek === this.periodEnd) {
        this.$refs.mainFactorsPeriod.dateValue = "С начала недели";
      } else if (firstDayLastWeek === this.periodStart && lastDayLastWeek === this.periodEnd) {
        this.$refs.mainFactorsPeriod.dateValue = "Прошлая неделя";
      } else if (today === this.periodEnd && sevenDayAgo === this.periodStart) {
        this.$refs.mainFactorsPeriod.dateValue = "Последние 7 дней";
      } else if (firstDayCurrentMonth === this.periodStart && today === this.periodEnd) {
        this.$refs.mainFactorsPeriod.dateValue = "Текущий месяц";
      } else if (firstDayLastMonth === this.periodStart && lastDayLastMonth === this.periodEnd) {
        this.$refs.mainFactorsPeriod.dateValue = "Прошлый месяц";
      } else if (
        this.periodStart === moment().startOf("day").subtract(1, "month").format("DD.MM.YYYY").toString() &&
        today === this.periodEnd
      ) {
        this.$refs.mainFactorsPeriod.dateValue = "Последний месяц";
      } else {
        this.$refs.mainFactorsPeriod.dateValue = period;
      }
    }
  },

  async created() {
    this.isDataLoading = true;

    this.getCurrencyLabel()
    await this.$store.dispatch("employees/getReferenceValues", "filial").then((res) => {
      this.filialItems = res.data.map((item) => ({ id: item.id, value: item.id, label: item.name }));

      if (this.$route.query.filial) {
        const c = this.filialItems.findIndex(
          (filial) => filial.value.toString() === this.$route.query.filial.toString(),
        );
        if (c !== -1) this.filialLocal = this.filialItems[c];
      }

      this.tableData.columns = [...this.getTableColumnsMainFactors];
      this.getDataWorkerMainFactors("shifts");
    });
  },

  methods: {
    getCurrencyLabel() {
      this.$store.dispatch("personalEmployee/getCurrencyLabel").then((result) => {
        this.currencyLabel = result;
      });
    },
    resetFilters() {
      this.filialLocal = null;
      this.$refs.mainFactorsPeriod.periodReset();
      this.periodStart = "";
      this.periodEnd = "";
      this.getDataWorkerMainFactors(this.switcherLocal);
    },
    getDataWorkerMainFactors(dataType) {
      const userId = this.$route.params.id;
      this.isDataLoading = true;
      this.$store
        .dispatch("personalEmployee/getDataWorkerMainFactors", {
          userId,
          dataType,
          periodStart: this.periodStart,
          periodEnd: this.periodEnd,
          filial: this.filialLocal !== null ? this.filialLocal.value : "",
        })
        .then((res) => {
          this.shiftsLocalData = [];
          this.summaryLocalData = [];
          if (dataType === "shifts") {
            this.shiftsLocalData = res.response.map((record) => {
              const intervals = record.intervals
                .map((interval, index) => {
                  if (index === record.intervals.length - 1) {
                    return `<div class="c-table__cell-values-value-not-border">${interval.start}-${interval.finish}</div>`;
                  }
                  return `<div class="c-table__cell-values-value">${interval.start}-${interval.finish}</div>`;
                })
                .join("");

              return {
                change: {
                  values: [
                    {
                      value: `<div class="c-table__cell-values-value-not-border">${record.datetime}</div>`,
                      rowspan: 1,
                      colId: 1,
                      countIntervals: record.intervals.length,
                    },
                    { value: intervals.length > 0 ? intervals : "&nbsp;", rowspan: 1, colId: 2 },
                  ],
                },
                placeOfWork: {
                  value: record.filial,
                },
                total: {
                  value: this.formatAmount(Number(record.sum_paid)),
                },
                mainPartSalary: {
                  value: this.formatAmount(Number(record.main_part_salary)),
                },
                variablePartSalary: {
                  value: this.formatAmount(Number(record.variable_part_salary)),
                },
                depreciation: {
                  value: this.formatAmount(Number(record.depreciation)),
                },
                rewardsShift: {
                  value: `${record.bonuses} / ${record.sum_bonus}`,
                },
                finesPerShift: {
                  value: `${record.fines} / ${record.sum_penalty}`,
                },
                dateTime: record.datetime,
                comment: record.comment ? record.comment : "",
                calculation_id: record.calc_id,
                isShowRow: true,
              };
            });
            this.tableData.records = [...this.shiftsLocalData];
          } else {
            this.summaryLocalData = res.response;
          }

          const queryFilters = {
            ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
            ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
            ...(this.filialLocal === null ? null : { filial: this.filialLocal.value }),
          };

          this.$router
            .replace({
              name: "personal-employee-main-factors",
              query: {
                ...queryFilters,
              },
            })
            .catch(() => {});

          this.isDataLoading = false;
        });
    },
    formatAmount(x) {
      if (!Number.isInteger(x)) {
        return x
          .toFixed(0)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    applyFilters() {
      const periodStart = this.$refs.mainFactorsPeriod.period.start.input;
      const periodEnd = this.$refs.mainFactorsPeriod.period.end.input;
      this.periodStart = periodStart;
      this.periodEnd = periodEnd;
      this.getDataWorkerMainFactors(this.switcherLocal);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-factors {
  &__filters {
    display: flex;
    margin-top: 39px;

    @media screen and (max-width: 700px) {
      flex-direction: column;
    }

    &__filial {
      max-width: 168px;
      width: 100%;

      @media screen and (max-width: 700px) {
        max-width: 100%;
      }
    }

    &__period {
      //max-width: 200px;
      //width: 100%;
      margin-left: 31px;

      ::v-deep & .c-input-container_period {
        transform: none;
        left: 0;

        @media screen and (max-width: 1205px) {
          left: -200px;
        }

        @media screen and (max-width: 805px) {
          left: -230px;
        }
        @media screen and (max-width: 767px) {
          left: 0;
        }
      }

      @media screen and (max-width: 700px) {
        margin-top: 27px;
        margin-left: 0;
        max-width: 100%;
      }
    }

    &__buttons {
      display: flex;
      align-items: flex-end;
      margin-left: 33px;

      &__reset {
        max-width: 120px;
        margin-left: 10px;
        @media screen and (max-width: 700px) {
          max-width: calc(50% - 5px);
          width: 100%;
        }
      }

      &__apply {
        max-width: 130px;
        @media screen and (max-width: 700px) {
          max-width: calc(50% - 5px);
          width: 100%;
        }
      }

      @media screen and (max-width: 700px) {
        margin-top: 30px;
        margin-left: 0;
      }
    }
  }

  &__switcher {
    margin-top: 35px;

    @media screen and (max-width: 700px) {
      margin-top: 30px;
    }
  }

  &__tabs {
    margin-top: 25px;
    padding-bottom: 60px;

    &__loader {
      margin-top: 24px;
      max-width: 1200px;

      @media screen and (max-width: 700px) {
        ::v-deep & .loader-overlay {
          width: calc(100% + 40px);
          left: -20px;
          border-right: none;
          border-left: none;
        }
      }
    }

    &__shifts {
      max-width: 1175px;
    }

    @media screen and (max-width: 700px) {
      margin-top: 0;

      &::v-deep .main-factors__tabs__summary {
        margin-top: 25px !important;
      }
    }

    &__in__shifts__table {
      & ::v-deep .c-table__column {
        white-space: nowrap;
      }
      @media screen and (max-width: 700px) {
        & ::v-deep .c-table__column {
          white-space: normal;
        }

        & ::v-deep .c-table__cell {
          text-align: center;
        }

        & ::v-deep .c-table__record:nth-child(1) .c-table__cell[colspan="1"],
        & ::v-deep .c-table__record:nth-child(2) .c-table__cell[colspan="1"] {
          text-align: left;
        }
      }
    }

    &__summary {
      margin-top: -12px;
      max-width: 1200px;
      display: flex;
      flex-wrap: wrap;

      @media screen and (max-width: 1100px) {
        justify-content: space-between;
      }

      @media screen and (max-width: 650px) {
        margin-left: -20px;
        width: calc(100% + 40px);
        max-width: calc(100% + 40px);
      }

      &__item {
        width: 366px;
        height: 390px;
        border: 1px solid #dfe4ef;
        box-sizing: border-box;
        margin-right: 32px;
        margin-top: 12px;

        @media screen and (max-width: 1100px) {
          width: calc(50% - 15px);
          max-width: calc(50% - 15px);
          margin-right: 0;
        }

        @media screen and (max-width: 650px) {
          border-left: none;
          border-right: none;
          border-bottom: none;
          height: auto;
          width: 100%;
          max-width: 100%;
          margin-top: 0;

          &:last-child {
            border-bottom: 1px solid #dfe4ef;
          }
        }

        &__summ {
          width: 100%;
          height: 164px;
          padding: 20px 25px;
          border-bottom: 1px solid #dfe4ef;
          display: flex;
          flex-direction: column;

          @media screen and (max-width: 650px) {
            padding: 20px 19px;
            height: 145px;
            border-bottom: none;
          }

          &__title {
            font-weight: 500;
            font-size: 18px;
            line-height: 22px;
          }

          &__count {
            font-weight: bold;
            font-size: 45px;
            line-height: 54px;
            margin-top: 16px;

            @media screen and (max-width: 700px) {
              margin-top: 8px;
            }

            & svg {
              font-size: 34px;
              vertical-align: -2px;
            }
          }

          &__time {
            display: flex;
            align-items: center;

            &__title {
              margin-left: 3px;
              font-weight: normal;
              font-size: 13px;
              line-height: 16px;
            }
          }
        }

        &__money {
          display: flex;
          flex-wrap: wrap;

          &__main {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 74px;

            &__title {
              font-size: 12px;
              line-height: 120%;
              text-align: center;

              @media screen and (max-width: 650px) {
                order: 1;
              }
            }

            &__count {
              font-weight: 500;
              font-size: 18px;
              line-height: 22px;

              & svg {
                font-size: 14px;
                vertical-align: -1px;
              }

              @media screen and (max-width: 650px) {
                margin-left: auto;
                order: 3;
              }
            }

            @media screen and (max-width: 650px) {
              height: auto;
              flex-direction: row;
              justify-content: flex-start;
              padding: 8px 20px;
            }
          }

          &__variable {
            height: 75px;
            width: 50%;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &__title {
              font-size: 12px;
              line-height: 120%;
              text-align: center;

              @media screen and (max-width: 650px) {
                order: 1;
              }
            }

            &__count {
              font-weight: 500;
              font-size: 18px;
              line-height: 22px;

              & svg {
                font-size: 14px;
                vertical-align: -1px;
              }

              @media screen and (max-width: 650px) {
                margin-left: auto;
                order: 3;
              }
            }

            &__amount {
              position: absolute;
              top: 5px;
              right: 7px;
              font-weight: bold;
              font-size: 12px;
              line-height: 120%;

              @media screen and (max-width: 650px) {
                margin-left: 6px;
                position: static;
                order: 2;
              }
            }

            &__grey {
              background: #f5f7fa;

              & .main-factors__tabs__summary__item__money__variable__count,
              & .main-factors__tabs__summary__item__money__variable__title {
                color: #8e9cbb;
              }
            }

            &__green {
              background: #d0f4e3;

              & .main-factors__tabs__summary__item__money__variable__amount {
                color: #12c971;
              }
            }

            &__red {
              background: #ffe6f2;

              & .main-factors__tabs__summary__item__money__variable__amount {
                color: #ff238d;
              }
            }

            @media screen and (max-width: 650px) {
              height: auto;
              width: 100%;
              flex-direction: row;
              justify-content: flex-start;
              padding: 8px 20px;
            }
          }

          &__depremal {
            height: 75px;
            width: 50%;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &__title {
              font-size: 12px;
              line-height: 120%;
              text-align: center;

              @media screen and (max-width: 650px) {
                order: 1;
              }
            }

            &__count {
              font-weight: 500;
              font-size: 18px;
              line-height: 22px;

              & svg {
                font-size: 14px;
                vertical-align: -1px;
              }

              @media screen and (max-width: 650px) {
                margin-left: auto;
                order: 3;
              }
            }

            &__amount {
              position: absolute;
              top: 5px;
              right: 7px;
              font-weight: bold;
              font-size: 12px;
              line-height: 120%;

              @media screen and (max-width: 650px) {
                margin-left: 6px;
                position: static;
                order: 2;
              }
            }

            &__grey {
              background: #f5f7fa;

              & .main-factors__tabs__summary__item__money__depremal__count,
              & .main-factors__tabs__summary__item__money__depremal__title {
                color: #8e9cbb;
              }
            }

            &__green {
              background: #d0f4e3;

              & .main-factors__tabs__summary__item__money__deprimal__amount {
                color: #12c971;
              }
            }

            &__red {
              background: #ffe6f2;

              & .main-factors__tabs__summary__item__money__deprimal__amount {
                color: #ff238d;
              }
            }

            @media screen and (max-width: 650px) {
              height: auto;
              width: 100%;
              flex-direction: row;
              justify-content: flex-start;
              padding: 8px 20px;
            }
          }

          &__incentives {
            height: 75px;
            width: 50%;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &__title {
              font-size: 12px;
              line-height: 120%;
              text-align: center;

              @media screen and (max-width: 650px) {
                order: 1;
              }
            }

            &__count {
              font-weight: 500;
              font-size: 18px;
              line-height: 22px;

              & svg {
                font-size: 14px;
                vertical-align: -1px;
              }

              @media screen and (max-width: 650px) {
                order: 3;
                margin-left: auto;
              }
            }

            &__amount {
              position: absolute;
              top: 5px;
              right: 7px;
              font-weight: bold;
              font-size: 12px;
              line-height: 120%;

              @media screen and (max-width: 650px) {
                margin-left: 6px;
                position: static;
                order: 2;
              }
            }

            &__grey {
              background: #f5f7fa;

              & .main-factors__tabs__summary__item__money__incentives__count,
              & .main-factors__tabs__summary__item__money__incentives__title {
                color: #8e9cbb;
              }
            }

            &__green {
              background: #d0f4e3;

              & .main-factors__tabs__summary__item__money__incentives__amount {
                color: #12c971;
              }
            }

            &__red {
              background: #ffe6f2;

              & .main-factors__tabs__summary__item__money__incentives__amount {
                color: #ff238d;
              }
            }

            @media screen and (max-width: 650px) {
              height: auto;
              width: 100%;
              flex-direction: row;
              justify-content: flex-start;
              padding: 8px 20px;
            }
          }

          &__fines {
            height: 75px;
            width: 50%;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &__title {
              font-size: 12px;
              line-height: 120%;
              text-align: center;

              @media screen and (max-width: 650px) {
                order: 1;
              }
            }

            &__count {
              font-weight: 500;
              font-size: 18px;
              line-height: 22px;

              & svg {
                font-size: 14px;
                vertical-align: -1px;
              }

              @media screen and (max-width: 650px) {
                order: 3;
                margin-left: auto;
              }
            }

            &__amount {
              position: absolute;
              top: 5px;
              right: 7px;
              font-weight: bold;
              font-size: 12px;
              line-height: 120%;

              @media screen and (max-width: 650px) {
                margin-left: 6px;
                position: static;
                order: 2;
              }
            }

            &__grey {
              background: #f5f7fa;

              & .main-factors__tabs__summary__item__money__fines__count,
              & .main-factors__tabs__summary__item__money__fines__title {
                color: #8e9cbb;
              }
            }

            &__green {
              background: #d0f4e3;

              & .main-factors__tabs__summary__item__money__fines__amount {
                color: #12c971;
              }
            }

            &__red {
              background: #ffe6f2;

              & .main-factors__tabs__summary__item__money__fines__amount {
                color: #ff238d;
              }
            }

            @media screen and (max-width: 650px) {
              height: auto;
              width: 100%;
              flex-direction: row;
              justify-content: flex-start;
              padding: 8px 20px;
            }
          }
        }
      }
    }
  }
}
</style>
